import* as Vue from 'vue';
// import { createApp } from 'vue/dist/vue.runtime.esm-bundler'
import { createApp } from 'vue/dist/vue.esm-bundler';
import { createStore } from 'vuex' 
import recipeHelpers from "./helper.js";
import App from './App.vue'
 
import VueSocketIO from 'vue-3-socket.io'
import SocketIO from 'socket.io-client'
require('@/assets/css/icons.min.css')  
require('@/assets/css/app.min.css')   
require('@/assets/css/style.css')   
 
import router from './router/index.js' 
import store   from './store';  
import { mapGetters, mapActions } from "vuex";
import jQuery from 'jquery' 
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas);
 
import { dom } from "@fortawesome/fontawesome-svg-core";
dom.watch(); 
//require('./bootstrap');
//require("unicons");
 
import notification from '@kyvg/vue3-notification' 
import "bootstrap/dist/js/bootstrap.min.js"; 
import Vue3Transitions from 'vue3-transitions'

import Toaster from '@meforma/vue-toaster';


import Toast, { PluginOptions } from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css'; 

// import vSelect from "vue-select";
// import "vue-select/dist/vue-select.css"; 

// import the component
// require("vue3-treeselect");
// import Vue3TreeSelect from "vue3-treeselect";
// // import the styles
// import 'vue3-treeselect/dist/vue3-treeselect.css';
 

// For ApexChart
import VueApexCharts from "vue3-apexcharts";
import moment from 'moment' 

import  VueHtmlToPaper from './plugins/VueHtmlToPaper'
 
window.Fire = createApp(App); 
const app = createApp(App); 

const eventBusApp = createApp({});
export const eventBus = eventBusApp;
import VueformMultiselect from '@vueform/multiselect/';

app.config.globalProperties.headers = {headers: {
                      'Authorization' : store.getters.token ? `Bearer ${store.getters.token}` : "",
                      'Content-Type': 'multipart/form-data' 
                    }};
app.config.globalProperties.headerjson = {headers: {
                      'Authorization' : store.getters.token ? `Bearer ${store.getters.token}` : "",
                      'Content-Type': 'application/json' 
                    }};
app.config.globalProperties.headerparams = {
                      'Authorization' : store.getters.token ? `Bearer ${store.getters.token}` : "",
                      'Content-Type': 'application/json' 
                    };

app.config.globalProperties.alloworigin = {headers: {
                      "Content-type": "application/json",
                      "Accept": "application/json",
                      "Access-Control-Allow-Origin": "*",
                      "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept" 
                    }};
                    
if((location.host == 'localhost:8081') || (location.host == '127.0.0.1:8081')){ 
	app.config.globalProperties.apiUrl =  "http://127.0.0.1:8001/api";
	app.config.globalProperties.baseUrl =  "http://127.0.0.1:8001";  
	app.config.globalProperties.imgUrl =  "http://127.0.0.1:8001";  
} else { 
    // app.config.globalProperties.apiUrl = "https://"+location.host+"/backend/api";
    // app.config.globalProperties.baseUrl = "https://"+location.host+"/backend";
    // app.config.globalProperties.sampleFileUrl = "https://"+location.host+"/backend/public";
    app.config.globalProperties.apiUrl = "https://api.subeasy.app/api";
    app.config.globalProperties.baseUrl = "https://api.subeasy.app"; 
    app.config.globalProperties.imgUrl =  "https://api.subeasy.app/public";  
}  
 
app.config.globalProperties.$createElement = '';
app.config.globalProperties.reRenderRoute = 0;

// for turn off warning
app.config.warnHandler = function (msg, vm, trace) {
  return null
}
// const cors = require('cors');
// app.use(cors());

app.use(router)    
app.use(notification) 
app.use(jQuery)   
app.use(store)   
app.use(Vue3Transitions)
app.use(Toaster)  
app.use(VueSweetalert2)  
app.component('Multiselect', VueformMultiselect)   
app.use(VueApexCharts); 
app.use(moment); 
app.use(VueHtmlToPaper) 
app.mount('#app');
 